import { useBooleanState } from '@retailer-platform/shared-components'
import { useCallback, useState } from 'react'
import { useCurrentAccountContext } from '../../../utils/current-account/CurrentAccountContext'
import { useNotifyOnPartnerWriteAccessError } from './PartnerWriteAccessErrorAlert'
import { BreakGlassModal } from './break-glass-modal/BreakGlassModal'

export const PartnerWriteAccessErrorNotifier = () => {
  const [breakGlassModalPartnerIds, setBreakGlassModalPartnerIds] = useState<number[]>([])
  const [breakGlassModalPartnerNames, setBreakGlassModalPartnerNames] = useState<string[]>([])
  const [isBreakGlassModalOpen, openBreakGlassModal, closeBreakGlassModal] = useBooleanState(false)

  const onOpenBreakGlassModal = useCallback(
    (partnerNames: string[], partnerIds: number[]) => {
      setBreakGlassModalPartnerNames(partnerNames)
      setBreakGlassModalPartnerIds(partnerIds)
      openBreakGlassModal()
    },
    [openBreakGlassModal]
  )

  const { account } = useCurrentAccountContext() || {}

  useNotifyOnPartnerWriteAccessError(account?.isInternal, onOpenBreakGlassModal)

  if (isBreakGlassModalOpen) {
    return (
      <BreakGlassModal
        isOpen={isBreakGlassModalOpen}
        onClose={closeBreakGlassModal}
        partnerIds={breakGlassModalPartnerIds}
        partnerNames={breakGlassModalPartnerNames}
      />
    )
  }

  return null
}
